import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    circleId: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    selectPhoto: PropTypes.func.isRequired,
    selectKeyvisual: PropTypes.func.isRequired,
    caller: PropTypes.string.isRequired,
  },
  getInitialState() {
    return {
      isActive: true,
      scrollPos: 0,
      photos: [],
    };
  },
  loadPhotosFromServer() {
    $.ajax({
      url: "/api/album/circle_photos",
      type: "GET",
      data: {
        circle_id: this.props.circleId,
      },
      cache: false,
      success: function(data) {
        this.setState({
          photos: data.photos,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  handleSelectPhoto(e) {
    if (this.props.caller == "keyvisual") {
      this.props.closeModal();
      this.props.selectKeyvisual(e);
    } else {
      this.props.closeModal();
      this.props.selectPhoto(e);
    }
  },
  closeModal() {
    this.props.closeModal();
  },
  handleRejectButton() {
    if (this.props.rejectFunc != undefined) {
      this.props.rejectFunc();
    }
    this.closeModal();
  },
  componentDidMount() {
    this.loadPhotosFromServer();
  },
  render() {
    const photos = this.state.photos.map(
      function(photo) {
        return (
          <label
            className="mb10 mr10 cursor-pointer"
            style={{ display: "inline-block" }}
            key={photo.id}
          >
            <input
              type="radio"
              name="photo"
              className="dsp-non"
              value={photo.photo_url}
              onClick={this.handleSelectPhoto}
            />
            <img src={photo.photo_url} height="120px" />
          </label>
        );
      }.bind(this)
    );
    return this.props.isActive ? (
      <div>
        <div className="modal-view">
          <div className="modal-view-fade-in">
            <div className="modal-view-overAll">
              <div
                className="modal-view-overlay"
                onClick={this.handleRejectButton}
              >
                <div className="modal-xBtn font-size-28 cursor-pointer">×</div>
              </div>
              <div className="modal-view-large-dialog">
                <div className="modal-view-content">
                  <div className="container">
                    <h4>画像を選択</h4>
                    <p className="small g-color-gray-dark-v4">
                      <i
                        className="fas fa-question-circle"
                        aria-hidden="true"
                      />{" "}
                      画像を追加するには、先に<a
                        href={`/circle/${this.props.circleId}/album/list`}
                      >
                        アルバムに画像を登録
                      </a>してください。
                    </p>
                    {photos}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      ""
    );
  },
});
